import { render } from "./SearchBar.vue?vue&type=template&id=0148be90"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"
script.render = render

export default script